<template>
  <div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <v-menu
        :close-on-content-click="false"
        offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
            class="ml-5"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
        >
          {{ languageData.generateVobDocument }}
          <v-icon class="ml-2">
            mdi-format-list-bulleted-square
          </v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item link v-for="document in vobDocumentsType" v-bind:key="document.value" @click="openDocumentModal(document.value)">
          <v-list-item-title>{{ languageData.documentProjectTypes[document.value] }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <ModalInfo :layout="'vobDocument'" :hidden-agree-btn="true" @clicked="hideVobDocument" :show-modal="isShowCreateVobDocumentModal">
      <template v-slot:body>
        <VobDocument />
      </template>
    </ModalInfo>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import { documentTypes } from "../../../Documents/enums/documentTypes";
import VobDocument from "../../../VobDocuments/components/VobDocument";
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "GenerateVOBDocument",
  components: { VobDocument },
  data() {
    return {
      vobDocumentsType: documentTypes.project.filter(el => 'vob' in el ),
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
    }
  },
  computed: {
    ...mapState("updateVisibleVobDocumentModal", {
      isShowCreateVobDocumentModal: state => state.isShowCreateVobDocumentModal
    }),
  },
  methods: {
    ...mapActions("updateVisibleVobDocumentModal", ["updateVisibleCreateVobDocumentModal"]),
    ...mapActions("vobDocuments", ["getVobDocumentRequest", "updateChosenType"]),
    openDocumentModal(documentType) {
      this.updateVisibleCreateVobDocumentModal(true);
      this.updateChosenType(documentType)
      this.getVobDocumentRequest();
    },
    hideVobDocument() {
      this.updateVisibleCreateVobDocumentModal(false);
    },
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
  },
  mounted() {
    eventBus.$on("saveVobDocumentSuccess", (data) => {
      this.getSnackBar(data.title, data.data.textInfo, "check_circle", "success");
      this.updateVisibleCreateVobDocumentModal(false);
    });
    eventBus.$on("sendVobDocumentSuccess", (data) => {
      this.getSnackBar(data.title, data.data.textInfo, "check_circle", "success");
      this.updateVisibleCreateVobDocumentModal(false);
    });
  }
}
</script>

<style scoped>

</style>